export function uuid() {
  let r = null
  let v = null

  /* tslint:disable:no-bitwise */
  const uniqueID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    r = Math.random() * 16 | 0
    v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
  /* tslint:enable:no-bitwise */

  return uniqueID
}

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
